import * as React from "react";
import ButtonUnstyled, {
  buttonUnstyledClasses,
} from "@mui/base/ButtonUnstyled";
import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";
import Script from "next/script";
import Link from "next/link";

const pink = {
  500: "#E33F84",
  600: "#e7106a",
  700: "#E33F84",
};

const useStyles = makeStyles((theme) => ({
  btnStyle: {
    all: "unset",
    fontFamily: "Inter",
    display: "inline-block",
    width: "100%",
    maxWidth:"346px",
    height: "56px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#000",
    fontSize: "16px",
    borderRadius: "12px",
    fontWeight: "600",
    fontStyle: "normal",
    cursor: "pointer",
    lineHeight: "56px",
    textAlign: "center",
    margin: "0",
    textDecoration: "none",
    background: "#fff",
    borderRadius: "12px",
    '@media(max-width:480px)':{
      width:"216px"
    },
  },
}));

const CustomButtonRoot = styled("span")`
  font-family: IBM Plex Sans, sans-serif;
  font-weight: bold;
  font-size: 20px;
  background-color: ${pink[500]};
  padding: 12px 48px;
  border-radius: 8px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  border: none;
  width: 250px;
  margin: auto;
  margin-top: 25px;
  text-align: center;
  &:hover {
    background-color: ${pink[600]};
  }

  &.${buttonUnstyledClasses.active} {
    background-color: ${pink[700]};
  }

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1),
      0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function CustomButton(props) {
  return <ButtonUnstyled {...props} component={CustomButtonRoot} />;
}

export default function ArtistSubmission() {
  const classes = useStyles();
  return (
    <div>
      {/* <Script src="//embed.typeform.com/next/embed.js"></Script>
      <button
        data-tf-popup="lZVwF1Ca"
        data-tf-size="70"
        data-tf-iframe-props="title=Registration Form"
        data-tf-medium="snippet"
        className={classes.btnStyle}
      >
        Artist Submission
      </button> */}

      <Link href="/artistsubmission">
        <button className={classes.btnStyle}>Register Now</button>
      </Link>
    </div>
  );
}
